import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { DEFAULT_LANGUAGE } from '../utils/languages';
import { applyLanguage } from './language';

/**
 * Keeps the UI in the language saved on the user's profile — the same one the roleplay
 * and its feedback use — so choosing Spanish turns the whole product Spanish. Signing
 * out leaves the last language in place for the login page.
 */
const UiLanguageSync: React.FC = () => {
  const { userData } = useAuth();
  // A profile with no language yet means English, not "whoever used this browser last".
  const language: string | undefined = userData ? userData.language || DEFAULT_LANGUAGE : undefined;

  useEffect(() => {
    if (language) applyLanguage(language);
  }, [language]);

  return null;
};

export default UiLanguageSync;
